export default __webpack_public_path__ + "static/media/InsideBrain_10.1c106af6.png";